module.exports = __webpack_public_path__ + "img/effenaar.e0dbf4ee.svg";